import ScheduleListRow from './ScheduleListRow';
export default class Member extends ScheduleListRow {
	constructor(params) {
		super(params);
		
		if (params.schedules !== undefined)
			this.schedules = params.schedules;
		else
			this.schedules = new Array();

		if (params.comment !== undefined)
			this.comment = params.comment;
		
		this.item_type = ScheduleListRow.ITEM_TYPE.MEMBER;
	}
}